export const settings = {
  selector: '.js-quizShow',
  $quiz() {
    return document.querySelector(this.selector);
  },
};
